import FolderIcon from "@material-ui/icons/Folder";
import shortenFileName from "../../../../../utils/commonFunctions/shortenFileName";
const Folder = ({ name }: { name: string }) => {
	return (
		<div className="file-icon" id="folder-icon">
			<FolderIcon style={{ fontSize: "5rem", color: "orange" }} />
			<p>{shortenFileName(name, 8)}</p>
		</div>
	);
};

export default Folder;
